import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";

const heroStyle = {
  paddingTop: 64,
  paddingBottom: 80,
  background:
    "linear-gradient(0deg, rgba(0,0,0,0.52), rgba(0,0,0,0.38)), url('https://res.cloudinary.com/american-legacy-tours/image/upload/f_auto,q_auto/img/cincinnati') no-repeat center center",
  backgroundSize: "cover",
};

const About = () => {
  return (
    <>
      <PageSEO
        title="About Us | American Legacy Tours"
        description="Learn about American Legacy Tours — Cincinnati's 2022, 2023 &amp; 2024 TripAdvisor Travelers' Choice Award winner. Historically entertaining walking tours since 2011."
        path="/about-us"
      />
      <section style={heroStyle}>
        <Container>
          <Row>
            <Col xs={12}>
              <h2
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
                  marginBottom: 32,
                  textShadow: "1px 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                Our Story
              </h2>

              <div className="glass-card">
                In 2009 a group of five friends in Newport, Kentucky embarked on a mission to
                support their local school through a unique fundraising event — the Newport
                Gangster Tour. Little did they know that this endeavor would mark the inception
                of American Legacy Tours, a venture fueled by a passion for storytelling and an
                unwavering commitment to unraveling the rich tapestry of Cincinnati and Northern
                Kentucky's history for both locals and visitors.
                <br />
                <br />
                The unexpected success of the Newport Gangster Tour was a catalyst, propelling
                the team to expand and establish American Legacy Tours officially. Our goal is to
                explore exclusive spaces of history with our guests and become America's premier
                tour company — informing, educating, and entertaining people with the unique
                histories of communities worldwide.
              </div>

              <div className="glass-card">
                In 2010, we introduced our second tour, the Queen City Underground Tour, nestled
                in the heart of Over the Rhine. Quickly gaining popularity, this tour became a
                cornerstone, delving into the history of OTR and Cincinnati's illustrious brewing
                heritage.
              </div>

              <div className="glass-card">
                Today, American Legacy Tours stands as a beacon of immersive experiences,
                boasting a diverse repertoire of guided tours that cater to a wide range of
                interests. Our seasonal Haunted Tours are a testament to our commitment to
                providing unforgettable and thrilling experiences. Whether you're seeking
                historical insights, spine-tingling tales, or culinary adventures, our portfolio
                spans Underground and Historic Tours to Haunted and Food &amp; Drink Tours.
                <br />
                <br />
                Beyond our scheduled tours, we proudly offer private tours tailored for corporate
                events, team-building, family celebrations, reunions, and special events.
              </div>

              <div className="glass-card">
                The acclaim we've received speaks volumes about the quality of our experiences.
                Cincinnati Magazine has honored us with the prestigious title of{" "}
                <strong>"Best Historical Tour."</strong> We've also been recognized by National
                Geographic, Forbes Travel, BBC America, Politico, New York Daily News, Midwest
                Living, Fodor's Travel, and Lonely Planet.
                <br />
                <br />
                We invite you to join us in exploring the fascinating region we call home.
                Prepare for an unforgettable journey through time and tales, as American Legacy
                Tours opens the door to the captivating history and hidden gems of our vibrant
                community.
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
